/**
 * This module defines the sub-routing for Submission component.
 * This module will be included and used inside the Router object.
 */

// Entry point to Submission component
import children from './children';

const Submission = () => import('./Wrapper');

const STEP_PATH_NAME = '';

export default [
  {
    path: '/submission/',
    component: Submission,
  }, {
    path: '/submission/:videoId',
    redirect: `/submission/:videoId/${STEP_PATH_NAME}${1}`,
    component: Submission,
    children: children.map((step, index) => ({
      path: `${STEP_PATH_NAME}${index + 1}`,
      component: step.component,
    })),
  },
];



// WEBPACK FOOTER //
// ./src/components/Submission/index.js